export default function CTASection() {
  const options = [
    {
      weight: "light",
      icon: "ri-survey-line",
      title: "足タイプ診断",
      subtitle: "まず自分の足を知る",
      desc: "3分でできる簡易チェック。自宅から気軽に始められます。",
      cta: "診断してみる",
      style: "bg-[#F5F0EA] text-[#1C1917] border border-[#E8C99A]/40",
      ctaStyle: "bg-[#1C1917] text-white hover:bg-[#44403C]",
      tag: "軽い・無料",
    },
    {
      weight: "medium",
      icon: "ri-chat-1-line",
      title: "LINEで相談",
      subtitle: "気軽に質問してみる",
      desc: "来店前に気になることを相談できます。返信は丁寧に対応します。",
      cta: "LINEで話しかける",
      style: "bg-[#1C1917] text-white border border-[#1C1917]",
      ctaStyle: "bg-[#E8C99A] text-[#1C1917] hover:bg-[#D4A574]",
      tag: "中程度・無料",
    },
    {
      weight: "heavy",
      icon: "ri-calendar-check-line",
      title: "来店予約",
      subtitle: "じっくり診断・提案を受ける",
      desc: "完全予約制で、あなただけの時間を確保してお待ちしています。",
      cta: "来店予約をする",
      style: "bg-[#FAFAF8] text-[#1C1917] border border-[#F0EBE3]",
      ctaStyle: "bg-[#1C1917] text-white hover:bg-[#44403C]",
      tag: "しっかり・推奨",
    },
  ];

  return (
    <section className="bg-[#F5F0EA] py-24 md:py-32">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        {/* Header */}
        <div className="text-center mb-14">
          <p
            className="text-[#B8895A] text-xs tracking-widest mb-4 uppercase"
            style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
          >
            Next Step
          </p>
          <h2
            className="text-3xl md:text-4xl font-bold text-[#1C1917] leading-snug mb-4"
            style={{ fontFamily: "'Noto Serif JP', serif" }}
          >
            「合わないのが普通」
            <br />
            を変えてみませんか？
          </h2>
          <p
            className="text-[#78716C] text-sm leading-loose max-w-lg mx-auto"
            style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
          >
            まず診断だけでも大丈夫。
            自分のペースで、一歩を踏み出してください。
          </p>
        </div>

        {/* Options */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 max-w-4xl mx-auto">
          {options.map((opt, i) => (
            <div key={i} className={`rounded-2xl p-7 flex flex-col gap-5 ${opt.style}`}>
              <div>
                <div className="flex items-center justify-between mb-4">
                  <div className="w-10 h-10 flex items-center justify-center bg-white/20 rounded-xl">
                    <i className={`${opt.icon} text-lg ${i === 1 ? "text-white" : "text-[#B8895A]"}`} />
                  </div>
                  <span
                    className={`text-[10px] px-2.5 py-1 rounded-full whitespace-nowrap ${
                      i === 1 ? "bg-white/15 text-white/70" : "bg-[#E8C99A]/20 text-[#B8895A]"
                    }`}
                    style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
                  >
                    {opt.tag}
                  </span>
                </div>
                <h3
                  className="text-lg font-bold mb-1"
                  style={{ fontFamily: "'Noto Serif JP', serif" }}
                >
                  {opt.title}
                </h3>
                <p
                  className={`text-xs mb-3 ${i === 1 ? "text-white/60" : "text-[#B8895A]"}`}
                  style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
                >
                  {opt.subtitle}
                </p>
                <p
                  className={`text-xs leading-loose ${i === 1 ? "text-white/70" : "text-[#78716C]"}`}
                  style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
                >
                  {opt.desc}
                </p>
              </div>
              <a
                href="#"
                className={`flex items-center justify-center gap-2 px-5 py-3 rounded-full text-sm font-semibold whitespace-nowrap transition-colors cursor-pointer mt-auto ${opt.ctaStyle}`}
                style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
              >
                {opt.cta}
                <i className="ri-arrow-right-line text-xs" />
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}